import { COUNTRIES } from "../constants/countries";
export const getCountryTelCode = (countryISO) => {
    const country = COUNTRIES.find((item) => item.iso === countryISO);
    if (country) {
        return country.prefix;
    }
};
//# sourceMappingURL=getCountryCode.js.map